import ApiClient from './apiClient';
import AssetService from './controllers/asset/AssetService';
import BookService from './controllers/book/BookService';
import FolderService from './controllers/folder/FolderService';
import ImageService from './controllers/image/ImageService';
import OrderService from './controllers/order/OrderService';
import UserService from './controllers/user/UserService';

export class ApiService {
  public user: UserService;

  public book: BookService;

  public image: ImageService;

  public folder: FolderService;

  public asset: AssetService;

  public order: OrderService;

  constructor() {
    this.user = new UserService(ApiClient);
    this.book = new BookService(ApiClient);
    this.image = new ImageService(ApiClient);
    this.folder = new FolderService(ApiClient);
    this.asset = new AssetService(ApiClient);
    this.order = new OrderService(ApiClient);
  }
}

const api = new ApiService();

export default api;
